import React, { PureComponent } from 'react'
import { SingleDatePicker } from 'react-dates'
import styles from './styles/date-picker.scss'
import moment from 'moment'
import 'react-dates/lib/css/_datepicker.css'

export default class DatePicker extends PureComponent {
  render() {
    const { id = 'date-picker', date, onDateChange, language, numberOfMonths = 1 } = this.props

    moment.locale(language)

    return (
      <div className={styles.datePicker}>
        <SingleDatePicker
          id={id}
          date={date}
          focused={true}
          numberOfMonths={numberOfMonths}
          onDateChange={onDateChange}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DatePicker.js